import { z } from 'zod';

import { passwordValidator } from '@workspace/auth/password';

export const signUpSchema = z.object({
  name: z
    .string({
      required_error: 'Name ist erforderlich.',
      invalid_type_error: 'Name muss eine Zeichenkette sein.'
    })
    .trim()
    .min(1, 'Name ist erforderlich.')
    .max(64, 'Maximal 64 Zeichen erlaubt.'),
  email: z
    .string({
      required_error: 'E-Mail ist erforderlich.',
      invalid_type_error: 'E-Mail muss eine Zeichenkette sein.'
    })
    .trim()
    .min(1, 'E-Mail ist erforderlich.')
    .max(255, 'Maximal 255 Zeichen erlaubt.')
    .email('Geben Sie eine gültige E-Mail-Adresse ein.'),
  password: z
    .string({
      required_error: 'Passwort ist erforderlich.',
      invalid_type_error: 'Passwort muss eine Zeichenkette sein.'
    })
    .min(1, 'Passwort ist erforderlich.')
    .max(72, 'Maximal 72 Zeichen erlaubt.')
    .refine((arg) => passwordValidator.validate(arg).success, {
      message: 'Passwort erfüllt nicht die Anforderungen.'
    })
});

export type SignUpSchema = z.infer<typeof signUpSchema>;
